<script lang="ts" setup>
  import type * as CSS from 'csstype'

  withDefaults(
    defineProps<{
      backgroundColor?: CSS.Property.BackgroundColor
      spinnerColor?: CSS.Property.Color
    }>(),
    {
      backgroundColor: 'var(--color-secondary-paper-light)',
      spinnerColor: 'var(--color-stroke-light)'
    }
  )
</script>

<template>
  <client-only>
    <div class="c-page-spinner">
      <CSpinner :color="spinnerColor" class="spinner" size="xl" />
    </div>
  </client-only>
</template>

<style lang="scss" scoped>
  .c-page-spinner {
    flex: 1;

    display: flex;
    justify-content: center;
    align-items: center;

    background-color: v-bind('backgroundColor');

    .spinner {
      margin: 32px;
      flex: 1;
    }
  }
</style>
